import React, { useEffect } from 'react';

export default function RefundPolicy() {
  useEffect(() => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }, []);
  return (
    <section className="refund-policy-page">
      <div className="container refund-policy-card">
        <div className="refund-policy-header text-center mb-5">
          <h2>Refund Policy</h2>
          <p className="refund-policy-revised" style={{textAlign:"center"}}>Last Revised: 31-05-2026</p>
        </div>
        <p>
          Thank you for choosing our services. Please read this Refund Policy carefully. By submitting an application or making any payment,
          you acknowledge and agree to the terms set forth below.
        </p>

        <h3>No Refunds</h3>
        <p>
          No refund is applicable for application fees, service charges, or any payments made through our platform. Refunds will not be
          encouraged for any reason.
        </p>

        <h3>Applicant Responsibility</h3>
        <p>
          It is the sole responsibility of the applicant to carefully review the application form, provide accurate information, and attach
          all required and relevant documents as specified in the application. Incomplete, incorrect, or missing information or documents
          may result in rejection, delays, or other adverse consequences for which the applicant remains fully liable.
        </p>

        <h3>Supporting Documents</h3>
        <p>
          Applicants must ensure that all supporting documents are complete, legible, and authentic. We do not assume responsibility for
          verifying the accuracy of submitted documents beyond the scope of our stated services. Any costs, losses, or penalties arising from
          inaccurate submissions are the responsibility of the applicant.
        </p>

        <h3>Contact</h3>
        <p>
          For questions or concerns about this policy, contact us at <a href="mailto:coordinator@mduschooled.in">coordinator@mduschooled.in</a>.
        </p>
      </div>

      <style>{`
        .refund-policy-page {
          background: #eef4fb;
          min-height: 100vh;
          padding: 80px 16px;
        }
        .refund-policy-card {
          max-width: 920px;
          margin: 0 auto;
          background: #ffffff;
          border-radius: 32px;
          border: 1px solid rgba(148, 163, 184, 0.18);
          box-shadow: 0 32px 80px rgba(15, 23, 42, 0.08);
          padding: 56px;
          text-align: left;
        }
        .refund-policy-header h2 {
          font-size: 2.6rem;
          font-weight: 800;
          color: #0f172a;
          letter-spacing: -0.03em;
          margin-bottom: 0.65rem;
          line-height: 1.1;
        }
        .refund-policy-revised {
          color: #475569;
          font-size: 0.95rem;
          margin-bottom: 1rem;
        }
        .refund-policy-card p,
        .refund-policy-card li {
          color: #334155;
          line-height: 1.85;
          font-size: 1rem;
          margin-bottom: 1rem;
          text-align: justify;
        }
        .refund-policy-card h3 {
          color: #0f172a;
          margin-top: 2.5rem;
          margin-bottom: 1rem;
          font-size: 1.55rem;
          font-weight: 700;
          letter-spacing: -0.02em;
        }
        .refund-policy-list {
          list-style: disc outside;
          padding-left: 1.3rem;
          margin-bottom: 1.4rem;
          text-align: left;
        }
        .refund-policy-list li {
          margin-bottom: 0.85rem;
        }
        .refund-policy-card a {
          color: #2563eb;
          text-decoration: none;
          font-weight: 600;
        }
        .refund-policy-card a:hover {
          text-decoration: underline;
        }
        .refund-policy-card strong {
          color: #0f172a;
        }
        @media (max-width: 991px) {
          .refund-policy-card {
            padding: 40px 28px;
          }
        }
        @media (max-width: 767.98px) {
          .refund-policy-card {
            padding: 30px 20px;
            border-radius: 24px;
          }
          .refund-policy-header h2 {
            font-size: 2rem;
          }
        }
      `}</style>
    </section>
  );
}
